var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.9987 3.33325C10.632 3.33325 7.08203 6.88325 7.08203 11.2499C7.08203 15.5333 10.432 18.9999 14.7987 19.1499C14.932 19.1333 15.0654 19.1333 15.1654 19.1499C15.1987 19.1499 15.2154 19.1499 15.2487 19.1499C15.2654 19.1499 15.2654 19.1499 15.282 19.1499C19.5487 18.9999 22.8987 15.5333 22.9154 11.2499C22.9154 6.88325 19.3654 3.33325 14.9987 3.33325Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4656 23.5833C18.8156 20.4833 11.2323 20.4833 6.54896 23.5833C4.43229 25 3.26562 26.9166 3.26562 28.9666C3.26562 31.0166 4.43229 32.9166 6.53229 34.3166C8.86562 35.8833 11.9323 36.6666 14.999 36.6666C18.0656 36.6666 21.1323 35.8833 23.4656 34.3166C25.5656 32.9 26.7323 31 26.7323 28.9333C26.7156 26.8833 25.5656 24.9833 23.4656 23.5833Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.3156 12.2334C33.5823 15.4668 31.2823 18.3001 28.099 18.6834C28.0823 18.6834 28.0823 18.6834 28.0656 18.6834H28.0156C27.9156 18.6834 27.8156 18.6834 27.7323 18.7167C26.1156 18.8001 24.6323 18.2834 23.5156 17.3334C25.2323 15.8001 26.2156 13.5001 26.0156 11.0001C25.899 9.65008 25.4323 8.41675 24.7323 7.36675C25.3656 7.05008 26.099 6.85009 26.849 6.78342C30.1156 6.50009 33.0323 8.93342 33.3156 12.2334Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6497 27.6501C36.5164 29.2668 35.4831 30.6668 33.7497 31.6168C32.0831 32.5334 29.9831 32.9668 27.8997 32.9168C29.0997 31.8334 29.7997 30.4834 29.9331 29.0501C30.0997 26.9834 29.1164 25.0001 27.1497 23.4168C26.0331 22.5334 24.7331 21.8334 23.3164 21.3168C26.9997 20.2501 31.6331 20.9668 34.4831 23.2668C36.0164 24.5001 36.7997 26.0501 36.6497 27.6501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon26);
export default __webpack_public_path__ + "static/media/icon-26.dbe6521fffca231e05177c001748707f.svg";
export { ForwardRef as ReactComponent };